(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("kontentManagement", [], factory);
	else if(typeof exports === 'object')
		exports["kontentManagement"] = factory();
	else
		root["kontentManagement"] = factory();
})(self, () => {
return 